<template>
  <div class="container-fluid">
    <dropdown>
      <btn type="primary" class="dropdown-toggle" :id="compare ? 'select-compare-display' : 'select-display'" > {{ title }} <span class="caret"></span> </btn>
      <template slot="dropdown">
        <li v-if="options.length < 1">
          <a @click="select(-1)" role="button">Add Custom Year</a>
        </li>

        <li v-else v-for="(option, index) in options">
          <a @click="select(option)" role="button">{{ option }}</a>
          <a v-if="showCustomField(index) && compare" @click="select(-1)" role="button">Add Custom Year</a>
        </li>
      </template>
    </dropdown>
  </div>
</template>

<script>
  import store from '../../store.js';
  import { bus } from '../../main.js';
  import { mapState, mapGetters } from 'vuex';

  export default {
      props: {
        title: { default: '---------'},
        options: {default: () => []},
        compare: {default: false},
      },
      data () {
          return { }
      },
      computed: {
        ...mapGetters([
            'getDataType',
          ])
      },
      methods: {
        customizeTable: function(value) {
          bus.$emit('customize-table', { year: value });
        },

        showCustomTable: function(index) {
          this.$prompt({
            title: 'Customize Report',
            content: 'Enter custom year below:',
            validator (value) {
              var regex = /^[0-9]+$/;

              if (value != 0) {
                if(value.length == 4) {
                  if ((value != "") && (!regex.test(value)))
                    return 'Please enter numeric values only!';
                } else return 'Only 4 digits values are allowed!';
              } else return 'Please enter a valid 4 digit year';
            }
          }).then((value) => {
              this.year = value;
              $('#select-compare-display').html(`${this.year} <span class="caret"></span>`);
              this.customizeTable(value);
            }).catch(() => {
                this.$notify('Request has been cancelled.')
              })
        },

        showCustomField: function(index) {
          let count = this.options.length;
          return ((index + 1) >= count) ? true: false;
        },

        select: function (option) {
          if(option < 0) {
            this.showCustomTable();
          } else {
            if (this.getDataType === 'shp') {
              if (this.compare) {
                $('#select-compare-display').html(`${option} <span class="caret"></span>`);
                store.dispatch('setComparitiveYear', option);
                bus.$emit('customize-table', { year: -1 });
              } else {
                  $('#select-display').html(`${option} <span class="caret"></span>`);
              }
              this.$emit('select', option);
            } else if (this.getDataType === 'xls' || this.getDataType === 'xlsx'){
                store.dispatch('setSelectedYear', option);
            }
          }
        },

        clearSelector: function(){
          if (this.compare) {
              $('#select-compare-display').html(`${this.title} <span class="caret"></span>`);
              store.dispatch('setComparitiveYear', null);
          }
          this.updateSelector = false;
        }
      },
      watch: {
        options: function(newOptions){
          this.clearSelector();
        }
      },
  }
</script>

<style lang="scss">
.modal-header { font-size: 1.4em; font-weight: 400; }
.modal-body {
  p { font-size: 1.2em !important; margin: 15px 0; }
  .form-group {
    input { height: 40px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/ReportDataSelector.vue